import React from 'react';
import SignupHeader from '../Register/signup_header';
import signupleft from '../../images/signupleft.webp';

/**
 * Same chrome as Login — bg-secondary, SignupHeader, two-column hero (image + form column).
 */
export default function AuthLayout({ children, imageSrc, title, description }) {
  const img = imageSrc || signupleft;

  return (
    <div className="min-h-screen bg-secondary">
      <SignupHeader />

      <div className="w-full mx-auto">
        <div className="flex items-center justify-center min-h-[calc(100vh-80px)]">
          <div className="w-full max-w-[1260px] mx-auto px-4 md:px-8">
            <div className="flex flex-col md:flex-row items-stretch gap-8 md:gap-16">
              <div className="flex-1 flex items-center justify-center md:max-w-[689px]">
                <img
                  src={img}
                  alt="NuLifeSpan Rx"
                  className="w-full h-auto object-contain"
                />
              </div>

              <div className="flex-1 flex items-center justify-center md:max-w-[490px]">
                <div className="w-full space-y-6">
                  {(title || description) && (
                    <div className="space-y-2 text-center md:text-left">
                      {title ? (
                        <h1 className="text-3xl md:text-4xl font-bold text-foreground">
                          {title}
                        </h1>
                      ) : null}
                      {description ? (
                        <p className="text-md text-foreground opacity-70">{description}</p>
                      ) : null}
                    </div>
                  )}
                  {children}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
